<template>
  <el-form :model="form" :rules="rules" ref="form">
    <el-form-item prop="companyName">
      <el-input
        v-model="form.companyName"
        @keyup.enter.native="primaryBtnClick"
        prefix-icon="el-icon-office-building"
        placeholder="请输入公司名称"
      ></el-input>
    </el-form-item>
    <el-form-item prop="userName">
      <el-input
        v-model="form.userName"
        @keyup.enter.native="primaryBtnClick"
        prefix-icon="el-icon-user"
        placeholder="请输入账号"
      ></el-input>
    </el-form-item>
    <el-form-item class="mt-24">
      <PrimaryBtn :loading="loading" @click="primaryBtnClick"> 下一步 </PrimaryBtn>
    </el-form-item>
  </el-form>
</template>

<script>
import PrimaryBtn from '../../components/LoginPrimaryBtn';
import { forgetPasswordStep1 } from '@/api/login-api';
import { cloneDeep } from 'lodash';
export default {
  name: 'StepFirst',
  components: {
    PrimaryBtn
  },
  data() {
    return {
      form: {
        companyName: '',
        userName: '',
      },
      rules: {
        companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        userName: [{ required: true, message: '请输入账户', trigger: 'blur' }],
      },
      loading: false,
    };
  },
  methods: {
    primaryBtnClick() {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        const { companyName, userName } = this.form;
        this.loading = true;
        forgetPasswordStep1({
          companyName,
          accountName: userName,
          source: 'supplyChain'
        })
          .then(res => {
            const { data, result } = res;
            this.loading = false;
            if (result !== 1) {
                return false;
            }
            this.$emit('on-success', cloneDeep(data))
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>
